import type { HomeSlice } from '../bs/home'

/**
 * Croatian overrides for the home screens.
 *
 * A short list — the home screen is mostly shared vocabulary. What moves:
 * *sigurnost* for safety, *stroj* for machine (and the masculine agreement
 * that comes with it), *bodovi* for points, *tjedan* for week, *tko* /
 * *netko*, *usporediti* for *uporediti*, and *tvrtka* for the company.
 */
export const home: Partial<HomeSlice> = {
  'home.report.text': 'Kvar, incident, sigurnost ili prijedlog za poboljšanje',
  'home.scan.text': 'Otvori prijavu za stroj pored kojeg stojiš',

  'home.rating.points': '{points} bodova ukupno',

  'home.fiveS.walkedOf.one': 'od {count} stroja obiđeno',
  'home.fiveS.walkedOf.few': 'od {count} stroja obiđeno',
  'home.fiveS.walkedOf.many': 'od {count} strojeva obiđeno',
  'home.fiveS.progress': 'Strojevi obiđeni ovaj mjesec',
  'home.fiveS.allWalked': 'Svi strojevi su obiđeni ovaj mjesec.',
  'home.fiveS.toWalk': 'Još nisu obiđeni',
  'home.fiveS.noMachines': 'U vašim pogonima nema aktivnih strojeva.',

  'home.tasks.soonCount.one': '{count} s rokom ovog tjedna',
  'home.tasks.soonCount.few': '{count} s rokom ovog tjedna',
  'home.tasks.soonCount.many': '{count} s rokom ovog tjedna',
  'home.tasks.nothingSoon': 'Ništa hitno ovog tjedna',
  // *netko*.
  'home.tasks.emptyText': 'Zadaci koje vam netko dodijeli uz prijavu pojaviće se ovdje.',

  'home.fiveS.explain':
    'Prosjek pored stoji samo da imate s čim usporediti svoj broj — računa se iz pogona koje vidite, nije rang i nigdje ne piše na kojem ste mjestu.',

  // *stroj* for the machines, *tko* / *netko*, and *postotak* for *procenat*.
  'leaderboard.explain.note':
    'Dio za 5S govori o strojevima koje je netko održavao, a ne o njemu — tko je prešao na zapušten centar ima nizak postotak upravo zbog toga. Prihvaćeni prijedlozi se dodaju na osnovu i mogu je samo podići: odbijen prijedlog ne oduzima ništa. Tko nije bio ni na jednom obilasku ili nema nijedan zadatak, ocjenjuje se samo po onome što ima, a dio koji nedostaje se ne računa kao nula.',
  'leaderboard.explain.ties':
    'Isti rezultat dijeli isto mjesto: dvoje s 82 su oboje drugi, a sljedeći je četvrti.',

  'home.fiveS.plant.all': 'Prosjek tvrtke',
}
